import { useCurrentProfile } from "PFCore/hooks/queries/profile";
import { AccessLevel, Template } from "PFTypes";

type UseCurrentGroupPermissionsReturn = {
  getActivityPermissions: (template: Template | undefined) => AccessLevel | undefined;
};

export const useCurrentGroupPermissions = (): UseCurrentGroupPermissionsReturn => {
  const { data: currentProfile } = useCurrentProfile();
  const ownGroup = currentProfile.permissionsGroup;
  const ownGroupPermissions = ownGroup.crossGroupPermissions[ownGroup.id];

  const getActivityPermissions = (template: Template | undefined): AccessLevel | undefined => {
    if (!template) {
      return undefined;
    }
    return ownGroupPermissions.activitiesAccessLevels[template.id];
  };

  return {
    getActivityPermissions
  };
};
